<mat-card
    class="trinta-card error-card mb-25 bg-white border-none d-block text-center"
>
    <mat-card-content>
        <div class="construction-icon">
            <i class="ri-tools-line"></i>
        </div>
        <h3>
            <span class="text-primary">¡EN CONSTRUCCIÓN!</span> Página en Desarrollo
        </h3>
        <p class="text-black fs-15">
            Estamos trabajando duro para traerte esta funcionalidad. ¡Vuelve pronto para ver las novedades!
        </p>
        <a routerLink="/home" mat-button>
            Volver al Inicio
            <i class="ri-send-plane-fill"></i>
        </a>
    </mat-card-content>
</mat-card>

